import { render, staticRenderFns } from "./CertificateMonth.vue?vue&type=template&id=e701c168&scoped=true"
import script from "./CertificateMonth.vue?vue&type=script&lang=js"
export * from "./CertificateMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e701c168",
  null
  
)

export default component.exports